import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "audiencelead",
    defaultRoutePath: "/audiences/audiencelead",
    menuItemScope: "audience",
    menuItemName: "audienceLeads",

    routes: [
        {
            path: "/audiences/audiencelead",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        
        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "preverify",
            Component: Wizards.Preverify,
        },
        {
            path: "blacklist",
            Component: Wizards.Blacklist,
        },
        {
            path: "rpocheck",
            Component: Wizards.RPOCheck,
        },
        {
            path: "savesegment",
            Component: Wizards.CreateSegmentationRule,
        },
        {
            path: "importmargo",
            Component: Wizards.ImportMargo,
        },
        {
            path: "campaignactivitycreate",
            Component: Wizards.CampaignActivityCreate,
        },
        
    ],

}

export default Module;
